!function(n){
  var e=n.document,
      t=e.documentElement,
      i=750,
      d=i/100,
      o="orientationchange"in n?"orientationchange":"resize",
      a=function(){
        var n=t.clientWidth;
        var cw = (n / d) > 100 ? 100 : (n / d);
        t.style.fontSize=cw+"px"
      };
    e.addEventListener&&(n.addEventListener(o,a,!1),e.addEventListener("DOMContentLoaded",a,!1));
    n.onload = a();
}(window);



// WEBPACK FOOTER //
// ./src/utils/rem.js